import { Tag } from "antd";

const EventRoleTag = ({ role }) => {
  return (
    <Tag
      color="#8193B1"
      style={{
        color: "#fff",
        fontSize: "12px",
        fontWeight: "500",
      }}
      bordered={false}
    >
      {role?.name}
    </Tag>
  );
};

export default EventRoleTag;
